import { Component, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { PrivacyAndTermsComponent } from '../../shared';

@Component({
    selector: 'app-privacy-policy',
    imports: [
        MatDialogModule,
        MatButtonModule,
        PrivacyAndTermsComponent
    ],
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {

  constructor(@Optional() private dialogRef: MatDialogRef<PrivacyPolicyComponent>, private location: Location) { }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    else {
      this.location.back();
    }
  }
}
